'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _taxonomyNodePropType = require('../PropTypes/taxonomyNodePropType');

var _taxonomyNodePropType2 = _interopRequireDefault(_taxonomyNodePropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(_ref) {
  var listType = _ref.listType,
      label = _ref.label,
      activeNode = _ref.activeNode,
      onClickChange = _ref.onClickChange,
      onClickLink = _ref.onClickLink;

  var handleClickedChange = function handleClickedChange() {
    onClickChange();
    onClickLink({
      completion: false,
      linkName: 'change'
    }, false);
  };

  var name = activeNode.name,
      links = activeNode.links;

  var www = listType === 'spots' && links && links.find(function (link) {
    return link && link.key === 'www';
  });
  var travel = listType === 'spots' && links && links.find(function (link) {
    return link && link.key === 'travel';
  });

  var subregionTitle = listType === 'subregions' ? ' Forecasts' : '';

  return _react2.default.createElement(
    'div',
    { className: 'quiver-taxonomy-navigator__header' },
    _react2.default.createElement(
      'div',
      { className: 'quiver-taxonomy-navigator__header-title' },
      listType === 'geonames' && label ? 'Select ' + label : '' + name + subregionTitle
    ),
    www ? _react2.default.createElement(
      'a',
      {
        href: www.href,
        onClick: function onClick() {
          return onClickLink({
            clickEndLocation: 'Map',
            destinationUrl: www.href,
            completion: true,
            linkName: 'View spots on map'
          }, true);
        }
      },
      'View spots on map'
    ) : null,
    listType === 'spots' && travel ? _react2.default.createElement(
      'a',
      {
        href: travel.href,
        onClick: function onClick() {
          return onClickLink({
            clickEndLocation: 'Travel',
            destinationUrl: travel.href,
            completion: true,
            linkName: 'View travel information'
          }, true);
        }
      },
      'View travel information'
    ) : null,
    _react2.default.createElement(
      'button',
      { onClick: handleClickedChange },
      'change'
    )
  );
};

Header.propTypes = {
  activeNode: _taxonomyNodePropType2.default,
  listType: _propTypes2.default.string,
  label: _propTypes2.default.string,
  onClickChange: _propTypes2.default.func,
  onClickLink: _propTypes2.default.func
};

exports.default = Header;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/TaxonomyNavigator/Header.js
// module id = 680
// module chunks = 11